/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Locale, LocaleKeys } from "../../model/locale";
import type { TGuideFilterItem } from "./guide.types";

/**
 * Client-side Favorites fallback filter.
 *
 * Used when the `/v2/guideMenuItems` API returns an empty list or fails.
 * Icon URLs are `null` — the view layer uses a bundled heart icon asset instead.
 *
 * Built by a function rather than a top-level const: `Locale.setLocale` runs
 * asynchronously during app startup, so a value captured at module-eval time
 * would freeze in as "" and the sidebar's label fallback would render the raw
 * filter id instead. Calling `Locale.getString` on demand avoids that.
 */
export const getGuideFavoritesFallbackFilter = (): TGuideFilterItem => ({
  id: "tivo:fgmi.1",
  label: Locale.getString(LocaleKeys.GUIDE_FILTER_FAVORITE),
  iconUrl: null,
  focusedIconUrl: null,
  isFavorite: true
});
